import { Paper, Stack, TablePagination } from "@mui/material";
import { styled } from "@mui/material/styles";

/**
 * Styled metaform editor content component
 */
export const EditorContent = styled(Stack, {
  label: "metaform-editor-content"
})(({ theme }) => ({
  minWidth: 0,
  padding: "26px 28px 40px",
  overflow: "auto",
  flex: 1,
  backgroundColor: "#f2f4f3",
  "& .MuiInputBase-input": {
    fontSize: 14.5,
    lineHeight: "20px"
  },
  "& .MuiInputLabel-root": {
    fontSize: 13
  },
  "& .MuiFormControlLabel-label": {
    color: "#4d4d4d",
    fontSize: 13.5,
    lineHeight: "20px"
  },
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(2)
  }
}));

/**
 * Styled metaform editor wrapper component
 */
export const EditorWrapper = styled(Stack, {
  label: "metaform-editor-wrapper"
})(({ theme }) => ({
  overflow: "hidden",
  flexDirection: "row",
  flex: 1,
  minWidth: 0,
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    overflow: "auto"
  }
}));

/**
 * Styled metaform editor drawer component
 */
export const EditorDrawer = styled(Paper, {
  label: "metaform-editor-drawer"
})(({ theme }) => ({
  flex: "0 0 280px",
  width: 280,
  minWidth: 280,
  height: "100%",
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  borderRadius: 0,
  boxShadow: "none",
  borderRight: "1px solid #e2e5e3",
  "& .MuiTab-root": {
    fontSize: 13,
    fontWeight: 500,
    lineHeight: "20px",
    minHeight: 48
  },
  "& .MuiTypography-subtitle1": {
    color: "#4d4d4d",
    fontSize: 12.5,
    fontWeight: 500,
    lineHeight: "18px"
  },
  "& .MuiInputBase-input": {
    fontSize: 14,
    lineHeight: "20px"
  },
  "& .MuiInputLabel-root": {
    fontSize: 12.5
  },
  "& .MuiFormControlLabel-label": {
    color: "#4d4d4d",
    fontSize: 13,
    lineHeight: "18px"
  },
  [theme.breakpoints.down("md")]: {
    flex: "none",
    width: "100%",
    minWidth: 0,
    height: "auto",
    borderRight: 0,
    borderBottom: "1px solid #e2e5e3"
  }
}));

/**
 * Styled secondary editor settings drawer component.
 */
export const EditorRightDrawer = styled(EditorDrawer, {
  label: "metaform-editor-right-drawer"
})(({ theme }) => ({
  borderLeft: "1px solid #e2e5e3",
  borderRight: 0,
  [theme.breakpoints.down("xl")]: {
    display: "none"
  }
}));

/**
 * Styled metaform editor section component
 */
export const EditorSection = styled(Paper, {
  label: "metaform-editor-section"
})(() => ({
  padding: "16px 18px",
  borderRadius: 4,
  boxShadow: "none",
  border: "1px solid #e2e5e3",
  borderLeft: "3px solid #278062"
}));

/**
 * Styled text for the form pagination
 */
export const FormPagination = styled(TablePagination, {
  label: "form-pagination"
})(() => ({
  overflow: "hidden",
  flexShrink: 0
}));

/**
 * Styled text for the form list container
 */
export const FormListContainer = styled(Stack, {
  label: "form-list-container"
})(() => ({
  overflow: "hidden",
  height: "100%"
}));

/**
 * Styled text for the forms container
 */
export const FormsContainer = styled(Stack, {
  label: "forms-container"
})(() => ({
  overflow: "auto",
  flex: 1
}));

/**
 * Styled drawer section component
 */
export const DrawerSection = styled(Stack, {
  label: "drawer-section"
})(({ theme }) => ({
  padding: theme.spacing(1),
  paddingTop: theme.spacing(2),
  gap: theme.spacing(2),
  borderTop: `1px solid ${theme.palette.grey[200]}`
}));